import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-redux-i18n';
import { Tooltip } from '@material-ui/core';
import { Icon, TextCheckbox } from 'front-onceforall-core';
import { PROJECT_ORGANISATION_ROLE as role } from '../../../utils/constant';
import ProjectInformation from './projectInformation';
import ProjectParticipants from './projectParticipants';
import ProjectDocuments from './projectDocuments';
import ProjectRequestList from './projectRequestList';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const ProjectDetailsView = props => {
  let deleteButton = /*#__PURE__*/_jsx("button", {
    "data-id": "delete",
    className: "large secondary inline-container",
    onClick: props.onDeleteProject,
    disabled: !props.isProjectDeletionAllowed,
    style: props.isProjectDeletionAllowed ? {} : {
      pointerEvents: 'none'
    },
    children: /*#__PURE__*/_jsx(Icon, {
      icon: "trash"
    })
  });
  deleteButton = props.isProjectDeletionAllowed ? deleteButton : /*#__PURE__*/_jsx(Tooltip, {
    "data-id": "delete-disabled-tooltip",
    title: /*#__PURE__*/_jsx(Translate, {
      value: 'project.page.buttonsDisabledTooltip'
    }),
    children: /*#__PURE__*/_jsx("span", {
      children: deleteButton
    })
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [!props.loading && !props.error && props.project && /*#__PURE__*/_jsxs("div", {
      className: "flex-container space-between",
      children: [/*#__PURE__*/_jsx("div", {
        className: "mb-5",
        children: /*#__PURE__*/_jsx("h1", {
          "data-id": "request-title",
          className: "ml-6 mb-0",
          children: props.project.name
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "col-md-5 inline-container flex-end",
        children: [props.isBackOffice && /*#__PURE__*/_jsx(TextCheckbox, {
          checked: props.project.unlimitedRfa,
          onChange: props.toggleUnlimitedRfa,
          name: 'unlimitedRfa',
          label: /*#__PURE__*/_jsx(Translate, {
            style: {
              color: '#00796b'
            },
            value: "project.unlimitedRfa"
          })
        }), props.isBackOffice && /*#__PURE__*/_jsxs("button", {
          type: "button",
          "data-id": "manage-owner",
          className: "large bo inline-container",
          onClick: props.openProjectOwnerTagEditionFormPanel,
          children: [/*#__PURE__*/_jsx(Translate, {
            value: "project.owner.title"
          }), /*#__PURE__*/_jsx(Icon, {
            icon: "cog"
          })]
        }), /*#__PURE__*/_jsxs("button", {
          type: "button",
          "data-id": "manage-user-permissions",
          className: "large secondary inline-container",
          onClick: props.onManageRolesPanelAction,
          children: [/*#__PURE__*/_jsx(Translate, {
            value: "project.userPermissions.title"
          }), /*#__PURE__*/_jsx(Icon, {
            icon: "cog"
          })]
        }), props.authorizedActions && /*#__PURE__*/_jsxs("button", {
          type: "button",
          "data-id": "invite-general-contractor",
          className: "large cta inline-container",
          onClick: () => props.onGeneralContractorInvitationPanelAction(true),
          children: [/*#__PURE__*/_jsx(Translate, {
            value: `project.invite.${role.PROJECT_GENERAL_CONTRACTOR}.button`
          }), /*#__PURE__*/_jsx(Icon, {
            icon: "plus"
          })]
        }), props.isProjectOwner && deleteButton]
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: "row",
      children: [/*#__PURE__*/_jsx(ProjectInformation, {
        actions: props.actions,
        project: props.project,
        error: props.error,
        loading: props.loading,
        isProjectEditionAllowed: props.isProjectEditionAllowed,
        onProjectUpdate: props.onProjectUpdate
      }), /*#__PURE__*/_jsx(ProjectDocuments, {
        projectId: props.projectId,
        isProjectEditionAllowed: props.isProjectEditionAllowed,
        onProjectUpdate: props.onProjectUpdate,
        actions: props.actions,
        error: props.error,
        loading: props.loading
      }), /*#__PURE__*/_jsx(ProjectParticipants, {
        projectId: props.projectId,
        organisation: props.organisation,
        authorizedActions: props.authorizedActions,
        isProjectEditionAllowed: props.isProjectEditionAllowed && props.isBackOffice,
        isPanelOpen: props.isGeneralContractorInvitationPanelOpen,
        onPanelAction: props.onGeneralContractorInvitationPanelAction,
        actions: props.actions
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "mt-5 pt-5",
      children: /*#__PURE__*/_jsx(ProjectRequestList, {
        projectId: props.projectId,
        project: props.project
        // allow action badges to display when user roles are modified
        ,
        actionBadgesUpdater: () => {}
      })
    })]
  });
};
ProjectDetailsView.propTypes = {
  project: PropTypes.object,
  projectId: PropTypes.number.isRequired,
  onManageRolesPanelAction: PropTypes.func.isRequired,
  openProjectOwnerTagEditionFormPanel: PropTypes.func.isRequired,
  isGeneralContractorInvitationPanelOpen: PropTypes.bool.isRequired,
  onGeneralContractorInvitationPanelAction: PropTypes.func.isRequired,
  authorizedActions: PropTypes.bool.isRequired,
  onDeleteProject: PropTypes.func.isRequired,
  isProjectOwner: PropTypes.bool.isRequired,
  isProjectEditionAllowed: PropTypes.bool.isRequired,
  isProjectDeletionAllowed: PropTypes.bool.isRequired,
  isBackOffice: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  error: PropTypes.bool.isRequired,
  actions: PropTypes.object.isRequired,
  organisation: PropTypes.object.isRequired,
  onProjectUpdate: PropTypes.func,
  toggleUnlimitedRfa: PropTypes.func
};
export default ProjectDetailsView;